
import request from '@/utils/request'

export function save(data) {
    return request({
        url: 'Order/save',
        method: 'post',
        data
    })
}

export function dispatchOrder(data) {
  return request({
      url: 'Order/dispatchOrder',
      method: 'post',
      data
  })
}

export function completedOrder(data) {
  return request({
      url: 'Order/completedOrder',
      method: 'post',
      data
  })
}

export function getSingle(data) {
    return request({
        url: 'Order/getSingle',
        method: 'post',
        data
    })
}

export function getPageList(data) {
    return request({
        url: 'Order/getPageList',
        method: 'post',
        data
    })
}

export function getQueryCount(data) {
  return request({
      url: 'Order/getQueryCount',
      method: 'post',
      data
  })
}


export function testSendEmail(data) {
  return request({
      url: 'Order/testSendEmail',
      method: 'post',
      data
  })
}



export function deleteObj(data) {
    return request({
        url: 'Order/delete',
        method: 'post',
        data
    })
}

export function getAll(data) {
    return request({
        url: 'Order/getAll',
        method: 'post',
        data
    })
}


export function getDetails(data) {
    return request({
        url: 'Order/getDetails',
        method: 'post',
        data
    })
}

export function getSpecialList(data) {
    return request({
        url: 'Order/getSpecialList',
        method: 'post',
        data
    })
}

export function addProcessNote(data) {
    return request({
      url: 'Order/addProcessNote',
      method: 'post',
      data
    })
  }
  export function updateStatus(data) {
    return request({
      url: 'Order/updateStatus',
      method: 'post',
      data
    })
  }

  export function exportOrder(data) {
    return request({
      url: 'Order/exportOrder',
      method: 'post',
      data
    })
  }
  export function syncOrders(data) {
    return request({
      url: 'Order/syncOrders',
      method: 'post',
      data
    })
  }

  export function getAertOrders(data) {
    return request({
      url: 'Order/getAertOrders',
      method: 'post',
      data
    })
  }
  
  